// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jQx09","big_text":"styles_big_text__-b9De","button":"styles_button__Y1KEv"};